/* istanbul ignore file */
import CategoryPage from './index';

const KeywordPage = CategoryPage;

export default KeywordPage;
